import { render, staticRenderFns } from "./page1.vue?vue&type=template&id=b16a5026&scoped=true&"
import script from "./page1.vue?vue&type=script&lang=js&"
export * from "./page1.vue?vue&type=script&lang=js&"
import style0 from "./page1.vue?vue&type=style&index=0&id=b16a5026&prod&lang=scss&"
import style1 from "./page1.vue?vue&type=style&index=1&id=b16a5026&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16a5026",
  null
  
)

export default component.exports